import React from 'react'
import styles from './styles.css'
import Logo from '../../Auth/Logo'
import {withRouter} from 'react-router'
import ReactGA from 'react-ga'
import Button from 'orionsoft-parts/lib/components/Button'

@withRouter
export default class NotFound extends React.Component {
  state = {isLoading: false, error: null}

  renderLogo() {
    return (
      <div className={styles.logo}>
        <Logo color="black" isLoading={this.state.isLoading} />
      </div>
    )
  }

  renderButtons () {
    return (
      <div className={styles.buttonsContainer}>
        <Button
          primary
          fullWidth
          to = "/"
        >
          REGRESAR
        </Button>
      </div>
    )
  }

  render() {
    ReactGA.initialize('UA-167106989-1');

    return (
      <div className={styles.root}>
        <div className={styles.paperContainer}>
          {this.renderLogo()}
          <div className={styles.msgText}>
            <p className={styles.titleText}> <b> 
                TU DOCUMENTO NO HA SIDO ENCONTRADO 
                <br/>
              </b>
            </p>
            <p className={styles.detailTextMini}>Es posible que tu documento haya sido cancelado</p>
          </div>
          {this.renderButtons()}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Misc/NotFound/index.js